// Everyday moments a habit can be stacked after. Clients localise them via
// `inbox.anchorMoment.<key>`; anything else in anchorMoment is the user's own words.
export const ANCHOR_MOMENTS = [
  'wake',
  'coffee',
  'teeth',
  'shower',
  'commute',
  'lunch',
  'home',
  'dinner',
  'bed',
] as const

export const ANCHOR_MOMENT_MAX = 60
